import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda/dist/ramda';
import { connect } from 'react-redux';
import { basketReducer } from '../../basket';
import {
  getStock,
  setLoading,
  setActiveRetailer as setActiveRetailerAction,
  getTotalPrice,
  setRemovingState,
  getProductsCount,
  getPurchaseUrlAsync as getPurchaseUrlAsyncAction,
  getRetailersWithProducts,
  getCartItems,
  trackBuyFromRetailer as trackBuyFromRetailerAction,
} from '../modules';
import { getBasketQuantity } from '../../basket/modules';

const {
  removeFromBasket: removeFromBasketAction,
  updateBasketItemQuantity: updateBasketItemQuantityAction,
} = basketReducer;

const ShoppingBagContainer = ({ childComponent: ChildComponent, ...props }) => (
  <ChildComponent {...props} />
);

const mapStateToProps = (state) => ({
  retailers: getRetailersWithProducts(state),
  itemsLength: getStock(state),
  productsLength: getProductsCount(state),
  totalProductPrices: getTotalPrice(state),
  activeRetailer: R.path(['shoppingBag', 'activeRetailer'], state),
  isLinkLoading: R.path(['shoppingBag', 'loading'], state),
  isBasketLoading: R.path(['basket', 'loading'], state),
  removeState: R.path(['shoppingBag', 'removeState'], state),
  sectionHeadings: R.path(['content', 'sectionHeadings'], state),
  checkout: R.path(['content', 'checkout'], state),
  items: R.pathOr([], ['basket', 'items'], state),
  cartID: R.path(['basket', 'cartID'], state),
  basketQuantity: getBasketQuantity(state),
  cartItem: getCartItems(state),
  basketConfiguration: R.path(['content', 'basketConfiguration'])(state),
});

const mapDispatchToProps = (dispatch) => ({
  removeFromBasket: (ean) => {
    dispatch(setRemovingState({ removing: true, ean }));
    setTimeout(() => {
      dispatch(removeFromBasketAction({ ean }));
      dispatch(setRemovingState({ removing: false, ean }));
    }, 1000);
  },
  setActiveRetailer: (retailer, index, total) =>
    dispatch(setActiveRetailerAction({ retailer, index, total })),
  updateBasketItemQuantity: (ean, quantity) => {
    if (quantity === 0) {
      dispatch(setRemovingState({ removing: true, ean }));
      setTimeout(() => {
        dispatch(removeFromBasketAction({ ean }));
        dispatch(setRemovingState({ removing: false, ean }));
      }, 1000);
    }

    return dispatch(updateBasketItemQuantityAction({ ean, quantity }));
  },
  getPurchaseUrlAsync: (retailerName, items) => {
    dispatch(setLoading(true));
    dispatch(getPurchaseUrlAsyncAction({ retailerName, items }));
  },
  trackBuyFromRetailer: () => dispatch(trackBuyFromRetailerAction()),
});

ShoppingBagContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShoppingBagContainer);
